/* eslint-disable max-len */
export const MyFavorites = "/ulubione";
export const Favorites = { url: "/api/favorites/%7Baction%7D", type: undefined as { action: string | number; } };
